import { render } from "./adminQuestionOnly.vue?vue&type=template&id=4e14513a&scoped=true"
import script from "./adminQuestionOnly.vue?vue&type=script&lang=js"
export * from "./adminQuestionOnly.vue?vue&type=script&lang=js"

import "./adminQuestionOnly.vue?vue&type=style&index=0&id=4e14513a&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e14513a"]])

export default __exports__